import * as yup from 'yup'

const schema = yup.object().shape({
  title: yup.string().required(),
  content: yup.string().richTextRequired(),
})

export default schema
